import React, {Component} from "react";
import './scss/step_wizard.css';
import {Alert, Container, Header, Footer, Card} from '@deere/ux.uxframe-react';
import CompanyTopHeader from './company-top-header';
import baseurl from '../../api-properties';
import {isMobile} from 'react-device-detect';
import {getAuthToken} from "../../reusable/basic-auth-creds";

if (isMobile) {
    import('../../mobileindex.css').then(() => {
    });
} else {
    import('../../index.css').then(() => {
    });
}

class SubmitCompanyInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyInfo: [],
        };
    }

    //This method can be used when fetch url  is ready.
    componentDidMount() {
        let prosSuppId = this.props.match.params.value;
        this.loadSupplierDetails(prosSuppId);
    }

    loadSupplierDetails = (prosSuppId) => {
        fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/getSupplier/" + prosSuppId + "/NULL", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": "Basic " + getAuthToken()
            }
        }).then((response) => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response.json();
        }).then(data => {
                console.log(data);
                this.setState({companyInfo: data});
            }).catch(error => {
            console.log(error);
        });
    }

    render() {
        return (
            <div>
                <Header pageHeading="Prospective Supplier"/>
                <div className="container-fluid bg-light">
                    <Container className="bg-light"> <br/>
                        <div class="row">
              <span class="col-sm-24" style={{textAlign: 'center'}}>
                <h3>John Deere Prospective Supplier Application Form</h3>
              </span>
                        </div>
                        <br/>
                        <div class="row">
              <span class="col-sm-24">
                <Alert>
                  <h5 class="uxf-alert-title">Application successfully started</h5>
                  <p class="uxf-alert-description">You will receive a confirmation email.Please follow the instructions within that email to continue your application.</p>
                </Alert>
              </span>
                        </div>
                        <div class="row">
              <span class="col-sm-24"><br/><br/>
                <div class="stepwizard">
                  <ul class="nav nav-justified">
                    <li class="nav-item in-process"><span>Application Submitted</span><small>In Process</small></li>
                    <li class="nav-item"><span>Under Review</span><small>In Complete</small></li>
                    <li class="nav-item"><span>Approve / Deny</span><small>In Complete</small></li>
                  </ul>
                </div><br/><br/>
              </span>
                        </div>
                        <div class="row">
              <span class="col-sm-24">
                <Card className="card-group">
                  <div class="card-body"><CompanyTopHeader companyInfoObj={this.state.companyInfo}/></div>
                </Card>
              </span>
                        </div>
                        <br/>
                    </Container>
                </div>
                <Footer/>
            </div>
        );
    }
}

export default SubmitCompanyInfo;